module.exports = __webpack_public_path__ + "img/img_hope01.1e5a7487.jpg";